import dayjs from "dayjs";

export const localTime = function (date, UtcOffset) {
  let formateDate = dayjs(date).format("YYYY/MM/DD HH:mm:ss");
  //safari issue
  let addUtcOffset =
    new Date(formateDate).getTime() + UtcOffset * 1000 * 60 * 60;
  return dayjs(new Date(addUtcOffset)).format("YYYY/MM/DD HH:mm:ss");
};

export const numFormat = function (val) {
  // return val.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
  // 2021/7/29 safari支援度差 暫時關閉
  return val;
};

export const showFlag = function (Code) {
  // console.log('Code', Code);
  let lowercase = Code.toLowerCase();
  let flag = require("@/assets/images/system/flag/" + lowercase + ".png");
  let html = `
    <span class="country_falg"><img src="${flag}"/ alt="flag-${lowercase}"> </span>
    <span class="country_code">${Code}</span>
  `;
  return html;
};

const lan = localStorage.getItem("AC_lan") || "EN";
export const formateDay = function (number) {
  switch (number) {
    case 0:
      return lan == "zh_TW" ? "星期日" : "Sunday";
    case 1:
      return lan == "zh_TW" ? "星期一" : "Monday";
    case 2:
      return lan == "zh_TW" ? "星期二" : "Tuesday";
    case 3:
      return lan == "zh_TW" ? "星期三" : "Wednesday";
    case 4:
      return lan == "zh_TW" ? "星期四" : "Thursday";
    case 5:
      return lan == "zh_TW" ? "星期五" : "Friday";
    case 6:
      return lan == "zh_TW" ? "星期六" : "Saturday";
  }
};

export const checkUri = function (text) {
  // 將換行轉成 <br>
  let html = text.replace(/\n/g, "<br>");

  // 用正則找網址，避免抓太多
  const urlRegex = /(https?:\/\/[^\s<>"'，。！？：；、)\]}]+)/g;

  html = html.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noreferrer noopener">${url}</a>`;
  });

  return html;
};

// AP-12844
// GSM 日期一律「直接顯示 API 回傳的日期部分」，不做任何時區換算
export const dateOnly = function (dateString) {
  if (!dateString) return dateString;
  return String(dateString).substring(0, 10);
};
